import Cookies from "js-cookie";
import { ACCESS_TOKEN } from "../../util/constants/APP_RESERVED_NAME";
import { API_HEADER } from "../../util/constants/HEADERS";

interface UserPoliticProps {
    politic_id: number;
}

export const SaveUserViewPolitic = async ( { politic_id } : UserPoliticProps) => {
    const user_json = JSON.parse(localStorage.getItem('asg_user') ?? '{}')
    
    return fetch(`${process.env.REACT_APP_API_URL}userPolitic/${user_json.id}/${politic_id}`, {
        method: 'POST',
        headers: {
            ...API_HEADER,
            Authorization: `Bearer ${Cookies.get(ACCESS_TOKEN)}`
        },
    })
    .then(res => res.json())
    .then(res => {
        return res;
    }) 
    .catch(_ => {
        return {
            status: false,
            data: false
        }
    })
}